import { render } from "./500.vue?vue&type=template&id=a9c7d6aa"
const script = {}
script.render = render

export default script